// extracted by mini-css-extract-plugin
export default {"springBottomSheet":"CustomBottomSheet_springBottomSheet__-h52w","sheet-inner":"CustomBottomSheet_sheet-inner__LOFtv"};